module.exports = __webpack_public_path__ + "static/img/banner-m-03.31070bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/banner-m-03.jpg
// module id = 112
// module chunks = 1